// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"1920c052","251":"9b21e945","348":"efea3860","571":"7f75a71b"}[chunkId] + ".chunk.js";
};